import { createApp } from 'vue'
import App from './App.vue'
import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap-icons/font/bootstrap-icons.css"
import "bootstrap/dist/js/bootstrap.js"
import router from './router';
import {createPinia} from "pinia";
import globalComponents from "@/components/common";
import './plugins/authGuard'


const app = createApp(App)
app.use(globalComponents)
app.use(router);
app.use(createPinia());
app.mount('#app')
